

export enum StorageKeys {
    TOKEN = 'token'
}
export enum NetworkFunctionTypes {
    RU = 'RU',
    CU = 'CU',
    DU = 'DU',
    CUCP='CUCP',
    CUUP='CUUP'
}
export enum AssetTypeName{
    IoA='IoA',
    gNB='gNB',
    Core='Core',
    XEdge='XEdge'

}
export enum AssetType{
    IoA=1,
    gNB=2,
    Core=3,
    XEdge=4

    // {
    //     "result": [
    //         {
    //             "id": 1,
    //             "name": "IoA"
    //         },
    //         {
    //             "id": 2,
    //             "name": "gNB"
    //         },
    //         {
    //             "id": 3,
    //             "name": "Core"
    //         },
    //         {
    //             "id": 4,
    //             "name": "XEdge"
    //         }
    //     ]
    // }
}


// 1.15 minutes
// 2. 1 hour
// 3.1 day
// 4.1 week
// 5.30 days

// filter
    // this.polarAzimuth=this.polarAzimuth.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
    // this.polarRoll=this.polarRoll.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
    // this.poloarTilt=this.poloarTilt.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);

    //tyg@@$!FJvgTD49



    // [
  
    //     {
            
    //         "name": "gNB-RU-1",
        
    //         "area": [[428, 82], [475,82], [428, 156], [475,156]]
    //     },
    //     {
            
    //         "name": "gNB-RU-2",
    //         "area": [[510, 82], [557,82], [510, 156], [557,156]]
    //     },
    //     {
           
    //         "name": "gNB-RU-3",
    //         "area": [[580, 82], [628,82], [580, 156], [628,156]]
    //     },
    //     {
           
    //         "name": "gNB-RU-4",
    //         "area": [[656, 82], [705,82], [656, 156], [705,156]]
    //     },
    //     {
            
    //         "name": "gNB-RU-5",
    //         "area": [[755, 82], [806,82], [755, 156], [806,156]]
    //     },
    //     {
            
    //         "name": "gNB-RU-6",
    //         "area": [[871, 82], [915,82], [871, 144], [915,144]]
    //     },
    //     {
           
    //         "name": "gNB-RU-7",
    //         "area": [[933, 82], [975,82], [933, 144], [975,144]]
    //     },
    //     {
            
    //         "name": "gNB-CU",
    //         "area": [[320, 326], [430,326], [320, 400], [430,400]]
    //     },
    //     {
            
    //         "name": "gNB-DU-1",
    //         "area": [[476, 326], [587,326], [476, 400], [587,400]]
    //     },
    //     {
            
    //         "name": "gNB-DU-2",
    //         "area": [[673, 326], [784,326], [673, 400], [784,400]]
    //     }
    
    // ]